import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { NgxSpinnerService } from 'ngx-spinner';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { AccountViewModel } from '../../business-entities/account-view-model';
import { StatusViewModel } from '../../business-entities/status-view-model';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { Features } from '../../business-entities/user-role-view-model';
import { AccountService } from '../../business-services/account.service';
import { CustomerService } from '../../business-services/customer.service';
import { DashboardService } from '../../business-services/dashboard.service';
import * as Enums from './../../../../../Autofacets-Core/src/app/utils/enums';
import { FeatureCode } from './../../../../../Autofacets-Core/src/app/utils/enums';
import { AddAccountComponent } from './add-account/add-account.component';
import { ViewAccountComponent } from './view-account/view-account.component';

@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
})
export class AccountsComponent implements OnInit {

  selectedCustomerId: any = null;
  accountListExcel: AccountViewModel[] = [];
  accountListPDF: AccountViewModel[] = [];
  accountsList: AccountViewModel[] = [];
  totalCount: number = 0;
  searchTerm: string;
  isAdvanceSearch: any;
  selectedStatus: number;
  selectedSync: number;
  SyncList: StatusViewModel[] = [];
  StatusList: StatusViewModel[] = [];
  userRoleRightsDetails: UserRoleMenu;
  customerGroupList: any;
  accountName: '';
  allowCompanyCreation:boolean;
  allowAccount:boolean;
  allowQuickSearch:boolean;
  features: Features[] = [];
  IsDMS: boolean;
  IsAddAccount: boolean;
  throttle = 100;
  scrollDistance = 1;

  constructor(private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private accountService: AccountService,
    private userService: UserDataService,
    private cdr: ChangeDetectorRef,
    private excelService: ExcelService,
    private service: CustomerService,
    private dashboardService: DashboardService,
    private secureStorage: SecureStorage,
    private _eref: ElementRef) { }

  ngOnInit(): void {
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[])
      .find(menu => menu.moduleId === Enums.ModuleNames.Accounts);
      this.getFeatures();
      this.accountService.accountListRequest.startRecordNumber = 0;
      this.accountsList = [];
    this.getAccountsList();
    this.StatusList = this.dashboardService.getStatusList();
    this.SyncList = this.dashboardService.getDmsStatusList();
  }

  onScrollDown(_ev) {
    if(this.totalCount > this.accountsList.length){
      this.accountService.accountListRequest.startRecordNumber = this.accountsList.length;
      this.getAccountsList();
    }
  }

  async getFeatures() {
    this.features = this.secureStorage.getKeyData('feature');
    if (this.features?.length > 0) {
      this.allowCompanyCreation = this.features.find(x => x.featureCode === FeatureCode.AllowCompanyCreation)?.isActive;
      this.allowAccount = this.features.find(x => x.featureCode === FeatureCode.AllowAccount)?.isActive;
      this.allowQuickSearch = this.features.find(x => x.featureCode === FeatureCode.AllowQuicksearch)?.isActive;
      this.IsDMS = this.features.find(x => x.featureCode === FeatureCode.DMS)?.isActive;
      this.IsAddAccount = this.features.find(x => x.featureCode === FeatureCode.AddAccount)?.isActive;
    }
  }

  onView(id: string) {

    this.accountService.customerId = id;
    if(id.length > 0 && id !== null) {
      let record = this.accountsList.find(x => x.accountId === id);
      this.accountService.accountNo = record.accountNo;
      this.accountService.accountName = record.accountName;
      this.accountService.accountId = record.accountNo;
    } else {
      this.accountService.accountNo = "";
      this.accountService.accountName = "";
    }

    const modalref = this.modalService.open(ViewAccountComponent, { size: 'lg', windowClass: 'EditPopup' });
    modalref.componentInstance.isFromServiceAdvisor = false;
    modalref.result.then((res) => {
      if (res.success) {
        this.ngOnInit();
      }});
  }

  onClose() {
    this.isAdvanceSearch = false;
  }

  onSearchFilter() {
    this.accountService.accountListRequest.startRecordNumber = 0;
    this.accountService.accountListRequest.searchTerm = this.searchTerm;
    this.accountsList = []
    this.getAccountsList();
  }

  onSearch() {
    if (this.customerGroupList == undefined) {
      this.getCustomerGroup();
    }
    this.isAdvanceSearch = true;
  }
  OpenSavedSearchListPopup() {
    // This is intentional
    }

  async getCustomerGroup() {
    this.spinner.show();
    await this.service.GetCustomerGroupDropdown().then((response) => {
      this.customerGroupList = response.responseObject.filter(x => x.isDisplay);
      this.customerGroupList = this.customerGroupList.sort((a, b) =>
        (b?.code || '').localeCompare(a?.code || '')
      );
      this.spinner.hide();
    }, _error => {
      this.spinner.hide();
    });
  }

  StatusChange(status: any) {
    if (status == undefined) {
      this.accountService.accountListRequest.statusId = Enums.StatusCode.All;
    } else {
      this.accountService.accountListRequest.statusId = status;
    }
    this.accountService.accountListRequest.startRecordNumber = 0;
    this.accountsList = [];
    this.getAccountsList();
  }

  SyncChange(status: any) {
    if (status == undefined) {
      this.accountService.accountListRequest.syncId = Enums.DmsSync.All;
    } else {
      this.accountService.accountListRequest.syncId = status;
    }
    this.accountService.accountListRequest.startRecordNumber = 0;
    this.accountsList = [];
    this.getAccountsList();
  }

  onApplyFilter() {
    this.AdvanceSearchSubmit();
  }

  AdvanceSearchSubmit() {

    this.accountService.accountListRequest.searchTerm = this.searchTerm;
    this.accountService.accountListRequest.startRecordNumber = Constant.startRecordNumber;
    this.accountsList = []
    this.getAccountsList();
    this.isAdvanceSearch = false;
  }


  async exportAsXLSX(): Promise<void> {
    this.spinner.show();
    this.accountService.accountListRequest.isForDocuments = true;
    await this.accountService.getAccountList(this.accountService.accountListRequest).then((response) => {
      this.spinner.hide();
      this.cdr.detectChanges();
      this.accountListExcel = this.accountDataMapper(response.responseObject);
      this.cdr.detectChanges();
    },_error => {
      this.spinner.hide();
    });
    this.accountService.accountListRequest.isForDocuments = false;
    this.spinner.hide();

    this.excelService.exportAsExcelFile(this.accountListExcel, 'accounts_af');
  }

  public async openPDF(): Promise<void> {
    this.spinner.show();
    this.accountService.accountListRequest.isForDocuments = true;
    await this.accountService.getAccountList(this.accountService.accountListRequest).then((response) => {
      this.spinner.hide();
      this.cdr.detectChanges();
      this.accountListPDF = this.accountDataMapper(response.responseObject);
      this.cdr.detectChanges();

    }).finally(()=>{
      this.spinner.hide();
    });
    this.accountService.accountListRequest.isForDocuments = false;

    const doc = new jsPDF();
    autoTable(doc, { html: '#accountPDF', margin: { top: 3, left: 3, right: 3, bottom: 3 }, styles: { fontSize: 8 } });
    doc.save('Account-List.pdf');
    this.spinner.hide();
  }

  onRefresh() {
    this.accountService.accountListRequest.startRecordNumber = 0;
    this.accountsList = []
    this.getAccountsList();
  }

  async getAccountsList() {
    this.spinner.show();

    await this.accountService.getAccountList(this.accountService.accountListRequest).then((response) => {
      this.spinner.hide();
      this.accountsList.push(...this.accountDataMapper(response.responseObject));
      if (response.responseObject?.result?.errorCode == "404") {
        this.totalCount = 0;
      } else {
        if(this.accountsList.length > 0) {
        this.totalCount = this.accountsList[0].totalCount;
      }
      }
    }, _error => {
      this.spinner.hide();
    });

  }

  onAdd() {
    const modalref = this.modalService.open(AddAccountComponent, { size: 'lg', windowClass: 'EditPopup' });
    modalref.componentInstance.isFromServiceAdvisor = false;
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
   });
  }
  @HostListener('document:click', ['$event'])
  onSearchBoxClose(event) {
    if (event) {
      if (!this._eref.nativeElement.getElementsByClassName('advanced-search-box')[0]?.contains(event.target)) {
        this.isAdvanceSearch = false;
      }
    }
  }

  private accountDataMapper(account: any) {
    let supperArray = [];
    if (account && account.length > 0) {
      for (let index = 0; index < account.length; index++) {
        const element = account[index];
        let single = Object();

        single.rowNumber = (this.accountService.accountListRequest.startRecordNumber + 1) + index;
        single.accountId = element.accountId;
        single.accountName = element.accountName;
        single.accountNo = element.accountNo;
        single.addressLine1 = element.addressLine1;
        single.addressLine2 = element.addressLine2;
        single.createdDate = element.createdDate? new Date(element.createdDate + 'Z') : null;
        single.updatedDate = element.updatedDate ? new Date(element.updatedDate + 'Z') : null;
        single.dmsSyncDate = element.dmsSyncDate ? new Date(element.dmsSyncDate + 'Z') : null;
        single.customerNo = element.customerNo;
        single.isActive = element.isActive;
        single.sourceType = element.sourceType;
        single.mobileNo = element.mobileNo;
        single.email = element.email;
        single.city = element.city;
        single.state = element.state;
        single.country = element.country;
        single.pincode = element.pincode;
        single.NoOfAccounts = element.accounts;
        single.totalCount = element.totalCount;
        supperArray.push(single);
      }
    }
    return supperArray;
  }
}
